const PARAMETERS_TYPES = {
    trafficSourceParameters: 'Traffic Source Parameters',
    callFlow: 'Call Flow',
    customParameters: 'Custom Parameters',
    callerInputParameters: 'Call Flow Parameters',
    callerIdentity: 'Caller Identity',
    sipHeaders: 'SIP Headers',
    rtb: 'RTB',
    ping: 'Ping',
    httpRouter: 'HTTP Router',
}

export {
    PARAMETERS_TYPES,
}
